<template>
  <div class="paginacao paginacao_cor-terciaria u-margem-superior-media"
    role="navigation" aria-label="Paginação" v-if="totalDeRegistros > 0 || exibirSemRegistros">
    <p class="paginacao__info">{{ faixaDeRegistros }}</p>
    <div class="paginacao__container">
      <p class="paginacao__info">
        Página {{ paginaAtual }} de {{ totalDePaginas }}
      </p>

      <ul class="paginacao__lista">
        <li class="paginacao__item" @click.prevent="irParaPrimeiraPagina()">
          <a class="paginacao__navegacao paginacao__navegacao_esquerda" title="Voltar para primeira página"
            v-bind:aria-disabled="!possuiPaginaAnterior" href="#">
            <i class="paginacao__icone far fa-arrow-to-left"></i>
          </a>
        </li>
        <li class="paginacao__item" @click.prevent="voltarParaPaginaAnterior()">
          <a class="paginacao__navegacao paginacao__navegacao_esquerda" title="Voltar para página anterior"
            v-bind:aria-disabled="!possuiPaginaAnterior" href="#">
            <i class="paginacao__icone far fa-arrow-left"></i>
          </a>
        </li>
        <li v-for="pagina in paginasDoIntervalo" @click.prevent="irParaPagina(pagina)" class="paginacao__item">
          <a v-if="pagina != paginaAtual" class="paginacao__link" href="#">{{ pagina }}</a>
          <a v-if="pagina == paginaAtual" class="paginacao__link" href="#" aria-current="page">{{ pagina }}</a>
        </li>

        <li class="paginacao__item" @click.prevent="irParaProximaPagina()">
          <a class="paginacao__navegacao paginacao__navegacao_direita" title="Ir para próxima página"
            v-bind:aria-disabled="!possuiProximaPagina" href="#">
            <i class="paginacao__icone far fa-arrow-right"></i>
          </a>
        </li>
        <li class="paginacao__item" @click.prevent="irParaUltimaPagina()">
          <a class="paginacao__navegacao paginacao__navegacao_direita" title="Ir para última página"
            v-bind:aria-disabled="!possuiProximaPagina" href="#">
            <i class="paginacao__icone far fa-arrow-to-right"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    paginaAtual: {
      type: Number,
      required: true,
    },
    totalDePaginas: {
      type: Number,
      required: true,
    },
    totalDeRegistros: {
      type: Number,
      required: true,
    },
    quantidadePorPagina: {
      type: Number,
      default: 15,
    },
    exibirSemRegistros: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      totalDePaginasAExibir: 5,
    };
  },
  computed: {
    faixaDeRegistros() {
      const totalDeRegistros = this.totalDeRegistros || 0;
      const primeiroRegistro = !totalDeRegistros
        ? 0
        : (this.paginaAtual - 1) * this.quantidadePorPagina + 1;
      const ultimoRegistro = Math.min(this.paginaAtual * this.quantidadePorPagina, totalDeRegistros);

      return `Exibindo de ${primeiroRegistro} a ${ultimoRegistro} de ${totalDeRegistros} registros`;
    },
    paginasDoIntervalo() {
      const tamanhoDaJanela = Math.min(this.totalDePaginasAExibir, this.totalDePaginas);
      const paginaInicialMaxima = this.totalDePaginas - tamanhoDaJanela + 1;
      const paginaInicialCentralizada = this.paginaAtual - Math.floor(tamanhoDaJanela / 2);
      const paginaInicial = Math.max(1, Math.min(paginaInicialCentralizada, paginaInicialMaxima));

      return Array.from({ length: tamanhoDaJanela }, (_, indice) => paginaInicial + indice);
    },
    possuiPaginaAnterior() {
      return this.paginaAtual > 1;
    },
    possuiProximaPagina() {
      return this.paginaAtual < this.totalDePaginas;
    },
  },
  methods: {
    voltarParaPaginaAnterior() {
      if (this.possuiPaginaAnterior) this.$emit("paginar", this.paginaAtual - 1);
    },
    irParaProximaPagina() {
      if (this.possuiProximaPagina) this.$emit("paginar", this.paginaAtual + 1);
    },
    irParaPrimeiraPagina() {
      if (this.possuiPaginaAnterior) this.$emit("paginar", 1);
    },
    irParaUltimaPagina() {
      if (this.possuiProximaPagina) this.$emit("paginar", this.totalDePaginas);
    },
    irParaPagina(pagina) {
      this.$emit("paginar", pagina);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Paginacao.vue?21262528